import {
  ScriptFunctionInfo,
  WorkcellInstrument,
  Workflow,
} from '@automata/wfb-api/src/apis/wfbApiSchemas';

import { getDataDependencyEdges } from './getDataDependencyEdges';
import getLabwareDependencyEdges from './getLabwareDependencyEdges';
import {
  buildNullNodePositions,
  getHandlePairIdOrderByNode,
  getTaskDependencies,
  getTimeConstraints,
} from './utils';
import { DriversByNameAndVersion } from '../../../data/drivers';
import { GraphState } from '../../../features/graph/graphSlice';
import { TaskType } from '../types';

export const getDeserializedGraphSlice = (
  workflow: Workflow,
  flatTasksById: Record<string, TaskType>,
  functions: ScriptFunctionInfo[],
  workcellInstruments: WorkcellInstrument[],
  driversByNameAndVersion: DriversByNameAndVersion
): GraphState => {
  const labwareIds = workflow.labware.map(({ id }) => id);
  const allTaskIds = Object.keys(flatTasksById);

  // Initialize labwareNodes and taskNodes with null positions
  const labwareNodes = buildNullNodePositions(labwareIds);
  const taskNodes = buildNullNodePositions(allTaskIds);

  const handlePairIdOrderByNode = getHandlePairIdOrderByNode(
    labwareIds,
    flatTasksById
  );

  const labwareDependencyEdges = getLabwareDependencyEdges(
    workflow,
    flatTasksById,
    handlePairIdOrderByNode
  );

  const taskDependencies = getTaskDependencies(workflow);
  const timeConstraints = getTimeConstraints(workflow);

  return {
    taskNodes,
    taskDependencies,
    labwareNodes,
    labwareDependencyEdges,
    timeConstraints,
    handlePairIdOrderByNode,
    labwareSlotMappingByTask: {}, // todo: look at this - seems to be to do with labware deck slots on hamilton?
    nodeIdToColorIndex: {},
    selectedEdges: [],
    selectedNodes: [],
    dataDependencyEdges: getDataDependencyEdges(
      workflow,
      functions,
      workcellInstruments,
      driversByNameAndVersion
    ),
  };
};
